// This creates something similar in concept to an enum.  Typescript enums have disadvantages so
// it's better to use this pattern.  It's explained more here: https://www.youtube.com/watch?v=jjMbPt_H3RQ
export const Permissions = {
	read_standard_segments_any: 'read:standard_segments:any',
	read_premium_segments_any: 'read:premium_segments:any',
	read_custom_segments_any: 'read:custom_segments:any',
	read_standard_segments_own: 'read:standard_segments:own',
	read_premium_segments_own: 'read:premium_segments:own',
	read_custom_segments_own: 'read:custom_segments:own',
	read_custom_segments_account: 'read:custom_segments:account',
	update_standard_segments_any: 'update:standard_segments:any',
	update_premium_segments_any: 'update:premium_segments:any',
	update_custom_segments_any: 'update:custom_segments:any',
	update_standard_segments_own: 'update:standard_segments:own',
	update_premium_segments_own: 'update:premium_segments:own',
	update_custom_segments_own: 'update:custom_segments:own',
	update_custom_segments_account: 'update:custom_segments:account',
	create_standard_segments: 'create:standard_segments',
	create_premium_segments: 'create:premium_segments',
	create_custom_segments: 'create:custom_segments',
	create_custom_segments_account: 'create:custom_segments:account',
	export_standard_segments_any: 'export:standard_segments:any',
	export_premium_segments_any: 'export:premium_segments:any',
	export_custom_segments_any: 'export:custom_segments:any',
	export_standard_segments_own: 'export:standard_segments:own',
	export_premium_segments_own: 'export:premium_segments:own',
	export_custom_segments_own: 'export:custom_segments:own',
	delete_standard_segments_any: 'delete:standard_segments:any',
	delete_premium_segments_any: 'delete:premium_segments:any',
	delete_custom_segments_any: 'delete:custom_segments:any',
	delete_standard_segments_own: 'delete:standard_segments:own',
	delete_premium_segments_own: 'delete:premium_segments:own',
	delete_custom_segments_own: 'delete:custom_segments:own',
	delete_custom_segments_account: 'delete:custom_segments:account',
	read_accounts_any: 'read:accounts:any',
	create_accounts_any: 'create:accounts:any',
	update_accounts_any: 'update:accounts:any',
	view_admin_page: 'view:admin_page',
	create_user_any: 'create:user:any',
	read_user_any: 'read:user:any',
	update_user_any: 'update:user:any',
	delete_user_any: 'delete:user:any',
	view_power_tools_page: 'view:power_tools_page',
	create_upload_account: 'create:upload:account',
	read_upload_account: 'read:upload:account',
	read_exports_any: 'read:exports:any',
	read_exports_account: 'read:exports:account',
	update_exports_any: 'update:exports:any',
	update_exports_account: 'update:exports:account',
} as const

type Keys = keyof typeof Permissions
export type Permission = (typeof Permissions)[Keys]
